import script from "./banjixinxi.vue?vue&type=script&setup=true&lang=js"
export * from "./banjixinxi.vue?vue&type=script&setup=true&lang=js"

import "./banjixinxi.vue?vue&type=style&index=0&id=c8b1e5d8&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8b1e5d8"]])

export default __exports__